import React from 'react';
import DOMPurify from 'dompurify';
import './reference.scss';
import { useIntl } from 'react-intl';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import {
  Button, Col, Icons, Row,
} from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { dateTimeFormatter, statusFormatter, userPositionFormatter } from '../../../utils/formatters';
import { NOTIFICATION_TEMPLATE_STATUS_NAMES } from '../../../configs';

export default function NotificationTemplateRegistryPopUp(props) {
  const {
    close = () => {}, handleDelete = () => {}, current = {}, handleEdit = () => {},
  } = props;
  const { formatMessage } = useIntl();

  const {
    procedures = [], status, created_at, creator, message, type_label,
  } = current;
  const cleanMessage = DOMPurify.sanitize(message);
  return (
    <Dialog
      className="rsr-popup-view"
      onClose={close}
      open
    >
      <DialogTitle header="Просмотр бланка уведомления" title={<Icons onClick={close} customIcon icon="close" className="close" />} />
      <DialogContent className="rsr-view-content">
        <div className="rsr-view-table">
          <Row className="row-cols-2">
            <Col className="rsr-view-label" columns={4}>Наименование уведомления</Col>
            <Col className="rsr-view-value" columns={8}>{current.name || ''}</Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="rsr-view-label" columns={4}>Применимая услуга</Col>
            <Col className="rsr-view-value" columns={8}>
              <ul>
                {(procedures || []).map((i, key) => (<li key={key}>{formatMessage({ id: `procedure.type.${i}` })}</li>))}
              </ul>
            </Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="rsr-view-label" columns={4}>Статус</Col>
            <Col className="rsr-view-value" columns={8}>
              {statusFormatter(status || 0, 'notification.template.status', NOTIFICATION_TEMPLATE_STATUS_NAMES)}
            </Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="rsr-view-label" columns={4}>Тип</Col>
            <Col className="rsr-view-value" columns={8}>{type_label}</Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="rsr-view-label" columns={4}>Дата создания</Col>
            <Col className="rsr-view-value" columns={8}>{dateTimeFormatter(created_at)}</Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="rsr-view-label" columns={4}>Автор</Col>
            <Col className="rsr-view-value" columns={8}>{userPositionFormatter(creator)}</Col>
          </Row>
          <Row className="row-cols-2">
            <Col className="rsr-view-label align-items-start" columns={4}>Шаблон</Col>
            <Col className="rsr-view-value" columns={8}>
              {/* html очищен!!! если ваш анализатор этого не понимает не используйте этот анализатор */}
              {/* eslint-disable-next-line react/no-danger */}{/* nosemgrep */}
              <div dangerouslySetInnerHTML={{ __html: cleanMessage }} />
            </Col>
          </Row>
        </div>
      </DialogContent>
      <DialogFooter className="hff-footer">
        {/* <Button variant="link" className="rsr-popup-box-button" onClick={e => { close(); handleDelete(current)(e); }}> */}
        {/*  <Icons customIcon icon="trash" /> */}
        {/* </Button> */}
        <Button onClick={handleEdit(current)}>Редактировать</Button>
      </DialogFooter>
    </Dialog>

  );
}
